import router from '../router';
import myhttp from '../plugins/baseHttp';

export const loginAction = ({ commit }, creds) => {
  commit('CLEAR_ALL_DATA');
  commit('UPDATE_LOGIN_ERROR', null);
  commit('PERFORMING_LOGIN', true);
  myhttp.login({
    username: creds.username,
    password: creds.password,
  }).then((result) => {
  //  commit('PERFORMING_LOGIN', false);
    if (result.status === 200 && result.statusText === 'OK') {
      router.push({ name: 'user-dashboard', params: { id: creds.username } });
    } else if (result.statusText !== 'OK' && result.status === 401) {
      commit('UPDATE_LOGIN_ERROR', 'Usuario no autorizado');
      commit('PERFORMING_LOGIN', false);
    } else {
      commit('UPDATE_LOGIN_ERROR', 'Error del login en el servicio');
      commit('PERFORMING_LOGIN', false);
    }
  });
};

export const updateErrorOverlay = ({ commit }, error) => {
  if (error && error.response) {
    switch (error.response.status) {
      case 422:
        commit('UPDATE_ERROR', 'Ha ocurrido un error. Revise los datos introducidos y vuelva a intentarlo.');
        break;
      case 403:
      case 401:
        commit('UPDATE_ERROR', 'No tiene permisos para realizar la acción.');
        break;
      default:
        commit('UPDATE_ERROR', 'Ha ocurrido un error, recargue la página y vuelva a intentarlo.');
        break;
    }
  }
  commit('CHANGE_OVERLAY');
};
export const logoutAction = () => {
  myhttp.logout();
};

export const changeScrollYAction = ({ commit }, payload) => commit('CHANGE_SCROLLY', payload);
export const changeWindowHeightAction = ({ commit }, payload) => commit('CHANGE_WINDOW_HEIGHT', payload);
export const changeWindowWidthAction = ({ commit }, payload) => commit('CHANGE_WINDOW_WIDTH', payload);
export const changeWindowDeviceAction = ({ commit }, payload) => commit('CHANGE_WINDOW_DEVICE', payload);



// WEBPACK FOOTER //
// ./src/store/actions.js